import React, { useCallback, useEffect, useState } from 'react'
import ArrowDownIcon from '../../../icons/ArrowDownIcon'
import useStyles from './ScrollArrow.styles'

const ScrollArrow: React.FC = () => {
  const classes = useStyles()

  const [iconOpacity, setIconOpacity] = useState(1)

  const onWindowScroll = useCallback(() => {
    if (window.pageYOffset > 200) {
      setIconOpacity(0)
    }
    setIconOpacity(1 - window.pageYOffset / 200)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onWindowScroll)
    return () => {
      window.removeEventListener('scroll', onWindowScroll)
    }
  }, [])

  return (
    <div
      className={classes.scrollOrbContainer}
      style={{ opacity: iconOpacity }}
    >
      <div className={classes.scrollOrb}>
        <ArrowDownIcon />
      </div>
    </div>
  )
}

export default ScrollArrow
